module.exports = __webpack_public_path__ + "src/assets/img/0.dd0b186d.png";